import {
  Autocomplete as AutocompleteBase,
  Chip as BaseChip,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${(p) => p.theme.spacing(3)};
  width: 100%;

  :not(.compact) {
    padding: ${(p) => p.theme.spacing(7, 10.5)};

    ${(p) => p.theme.breakpoints.down('lg')} {
      padding: 40px 20px;
    }

    /* @media (max-height: 800px) {
      padding: ${(p) => p.theme.spacing(6)} ${(p) => p.theme.spacing(12)};
    } */
  }
`;

export const Description = styled(Typography)`
  background: linear-gradient(90deg, #000 -4.5%, #666 99.86%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(p) => p.theme.spacing(3)};
  font-weight: 700;
  text-align: start;
  width: 100%;

  ${(p) => p.theme.breakpoints.down('md')} {
  }

  @media (max-height: 800px) {
  }
`;

export const DescriptionWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const InputPaper = styled(Paper)`
  :not(.compact) {
  }

  background-color: transparent;
  width: 100%;
`;

export const Autocomplete = styled(AutocompleteBase<string, true, true, true>)`
  height: 100%;
  width: 100%;

  .Mui-Autocomplete-poper {
    display: none;
  }
`;

export const Input = styled(TextField)`
  border: solid 1px ${(p) => p.theme.palette.grey['300']};
  border-radius: ${(p) => p.theme.spacing(1)};
  background-color: ${(p) => p.theme.palette.common.white};

  & > div {
    padding: ${(p) => p.theme.spacing(1)} !important;
    height: ${(p) => p.theme.spacing(5)};

    input {
      padding: 2.5px 4px 2.5px 8px !important;
    }

    > fieldset {
      border: none;
      border-radius: 0;
    }
  }

  box-sizing: content-box;
  /*:hover {
    border: solid 1px ${(p) => p.theme.palette.primary[100]};
  }*/

  &:hover {
    border: 1px solid ${(p) => p.theme.palette.primary[300]};
    -moz-box-shadow: 0 0 0 4px ${(p) => p.theme.palette.primary[50]};
    -webkit-box-shadow: 0 0 0 4px ${(p) => p.theme.palette.primary[50]};
    box-shadow: 0 0 0 4px ${(p) => p.theme.palette.primary[50]};
  }
`;

export const SearchButton = styled(Button)`
  height: ${(p) => p.theme.spacing(5)};
  white-space: nowrap;
`;

export const Chip = styled(BaseChip)`
  background-color: ${(p) =>
    p.theme.palette.mode === 'dark'
      ? p.theme.palette.background.neutral
      : p.theme.palette.primary[50]};

  & > .MuiChip-label {
    color: ${(p) => p.theme.palette.primary[500]};
  }

  :hover,
  &.active {
    background-color: ${(p) =>
      p.theme.palette.mode === 'dark'
        ? p.theme.palette.background.neutral
        : p.theme.palette.primary[50]};
  }
`;

export const SearchButtonWrapper = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SearchBarRow = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: ${(p) => p.theme.spacing(1)};
  align-items: center;
  flex-wrap: nowrap;

  > :first-of-type {
    width: 100%;
  }
`;

export const SearchModeText = styled(Typography)`
  font-weight: ${(p) => p.theme.typography.fontWeightBold};
`;

export const PoweredByText = styled(Typography)``;

export const SearchModeWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(2)};
`;

export const StatisticsCardWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(5)};
`;

export const LeftSideWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(2)};
`;

export const DetailWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
